/*
 *   Copyright (c) 2021 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
export const REGEX = {
  // regex for GSTIN number
  exp_GSTIN: '/^[0-9]{2,2}[a-zA-Z]{5,5}[0-9]{4,4}[a-zA-Z]{1,1}[1-9a-zA-Z]{1,1}[a-zA-Z]{1,1}[0-9a-zA-Z]{1,1}$/',
  // regex for mobile and email id
  exp_mail: /^(([_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]([\w\-])+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,6})))+$/,
  //         /^(?:\d{10,11}|([_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})))$/
  // regex for OTP
  exp_OTP: "/^[0-9]{6}$/",
  // regex for phone '/^[0-9]{10}$/'
  exp_phone: '/^[0-9]{6,13}$/',
  // regex for PAN
  exp_PAN: '/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/',
  // regex for IFSC code
  exp_IFSC: '/^[A-Za-z]{4}0[A-Za-z0-9]{6}$/',
  // regex for bankAccountNumber
  exp_accountNumber: '/^[0-9]{9,18}$/',
  // regex for pincode
  exp_pincode: '/^[0-9]{4,7}$/',
  // regex for aadharNumber
  exp_aadhar: '/^[0-9]{12}$/',
  // regex for ESI
  exp_esi: '/^[0-9]{17}$/',
  // regex for vehicle
  exp_vehicleNumber: '/^[A-Z0-9]{7,10}$/',
  exp_vehicleRegistrationNumber: '/^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/',
  // jdx account number (temporary)
  exp_jdxAccountNumber: "/^[a-zA-Z0-9]{0,20}$/",
  // regex for any url validation
  exp_urlverf: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
  // regex for ISO Date format
  exp_isoDate: /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,
  exp_floatValue: /[+-]?\d+(\.\d+)?/g,
}
